<template>
  <div class="thumb">
    <div class="image" :style="`background-image:url(${hqThumbnail});`"></div>
    <div class="infoBG"></div>
    <div class="infoBox"><span class="seqNum">{{index}}</span>
    <span class="title" v-html="title"></span>
    <span class="videoCount">{{createdDate}}</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import '../../assets/semantic-ui/components/image.min.css'

export default {
  props: ['thumbnail', 'title', 'created', 'index'],
  data () {
    return {
      loaded: false,
    };
  },
  computed: {
    createdDate () {
      const offset = Date.now() - this.created;
      if (offset >= 7 * 24 * 60 * 60 * 1000) {
        return moment(this.created).format('MMMM D');
      } else {
        return moment(this.created).fromNow();
      }
    },
    hqThumbnail () {
      let matches = /https?:\/\/img.youtube.com\/vi\/(.*)\//.exec(this.thumbnail);
      let videoId = matches && matches[1];
      if (videoId) {
        return `http://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
      } else {
        return this.thumbnail;
      }
    },
  },
}
</script>

<style>

.thumb {
  height: 20vw;
}

.thumb .seqNum {
  position: absolute;
  left: .1vw;
  bottom: .7vw;
  font-size: 2vw;
  width: 2.4vw;
  height: 2vw;
  line-height: 2.2vw;
  font-weight: bold;
  text-align: center;
}

.thumb .title {
  position: absolute;
  right: 0;
  bottom: .4vw;
  font-size: .9vw;
  line-height: 1.1vw;
  height: 2.2vw;
  width: calc(100% - 2.4vw);
  opacity: .9;
  padding: 0 .5vw;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  text-shadow: 0.01vw 0.01vw 1px rgba(0, 0, 0, 0.3);
}

.thumb .infoBox {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-family: Helvetica, Arial, sans-serif;
  font-weight: 200;
}

.thumb .videoCount {
  position: absolute;
  top: .25vw;
  right: 0;
  font-size: 1vw;
  text-shadow: none;
  background: linear-gradient(to right, #e17b94, #684a94);
  padding: .2em .8em;
  opacity: 1;
  border-radius: .8vw;
  box-shadow: 0 0 0.2vw 0 rgba(0, 0, 0, 0.7);
  font-weight: bold;
  transform: scale(.8);
}

.infoBG {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3.1vw;
  background-image: linear-gradient(to right, rgba(225, 123, 148, 1), rgba(225, 123, 148, 0));
}
.thumb .image {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 3.1vw;
  right: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
